import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BaseService } from '@library-shared/base/base.service';
import { ApiRecordReturn } from '@library-shared/models/api-record-return';
import { spSite_Client_By_DomainX } from '@models/StoredProcs-Extended/spSite_Client_By_DomainX';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class SiteService extends BaseService {
    private apiURL = environment.apiURL + '/api/site'; // URL to web api

    Site_Info(): Observable<ApiRecordReturn<spSite_Client_By_DomainX>> {
        const url = `${this.apiURL}/Site_Info`;
        return this.http
            .post<ApiRecordReturn<spSite_Client_By_DomainX>>(url, {}, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }
}
